export enum RentalDocumentTypeEnum {
  CountyRegistration = 'CountyRegistration',
  Additional = 'Additional',
}

export const rentalDocumentTypeMap: Record<RentalDocumentTypeEnum, string> = {
  [RentalDocumentTypeEnum.CountyRegistration]: 'County Registration',
  [RentalDocumentTypeEnum.Additional]: 'Additional Document',
};
